(function () {
  const Core = window.RB.Core;
  const { equip, buff } = window.RB.CardLib;

  window.RB.CardScripts = window.RB.CardScripts || {};
  Object.assign(window.RB.CardScripts, {
    "Armed Assailant": {},

    "Assembly Rig": {
      abilities: [
        {
          cost: { energy: 1, pips: 1, anyPower: 0, domains: ["fury"] },
          costRecycleTrash: 1,
          costRecycleType: "unit",
          exhausts: true,
          label: "Assembly Rig",
          targets: [],
          program: [{ op: "token", name: "Mech", n: 1, loc: "base", exhausted: false }],
        },
      ],
    },

    "Danger Zone": {
      play: [
        {
          op: "grant",
          spec: { type: "unit", friendly: true, tag: "Mech" },
          might: 1,
          dur: "turn",
        },
      ],
      repeatCosts: [{ cost: { energy: 1, pips: 0, anyPower: 1, domains: null } }],
    },

    "Ferrous Forerunner": {
      deathknell: [{ op: "token", name: "Mech", n: 2, loc: "base", exhausted: false }],
    },

    "Gem Jammer": {
      play: [{ op: "grant", to: "$t1", keyword: "ganking", dur: "turn" }],
      targets: [{ bind: "t1", spec: { type: "unit" }, prompt: "Give [Ganking] to..." }],
    },

    "Long Sword": {
      play: [{ op: "attachSource", to: "$_qd" }],
      targets: [
        {
          bind: "_qd",
          spec: { type: "unit", friendly: true },
          prompt: "Attach Long Sword to which unit?",
        },
      ],
      abilities: [
        equip({ energy: 0, pips: 1, anyPower: 0, domains: ["fury"] }),
      ],
    },

    "Recurve Bow": {
      abilities: [
        equip({ energy: 0, pips: 1, anyPower: 0, domains: ["fury"] }),
      ],
      attachedTriggers: [
        {
          on: "attack",
          optional: false,
          label: "When I attack or defend, deal 2 to an enemy unit here",
          targets: [
            {
              bind: "t1",
              spec: { type: "unit", enemy: true, here: true },
              prompt: "Deal 2 to...",
            },
          ],
          program: [{ op: "deal", to: "$t1", n: 2 }],
          self: true,
        },
        {
          on: "defend",
          optional: false,
          label: "When I attack or defend, deal 2 to an enemy unit here",
          targets: [
            {
              bind: "t1",
              spec: { type: "unit", enemy: true, here: true },
              prompt: "Deal 2 to...",
            },
          ],
          program: [{ op: "deal", to: "$t1", n: 2 }],
          self: true,
        },
      ],
    },

    "Sentinel Adept": {},

    "Serrated Dirk": {
      abilities: [
        equip({ energy: 0, pips: 1, anyPower: 0, domains: ["fury"] }),
      ],
      attachedKw: [["assault", 2]],
    },

    "Skyfall of Areion": {
      abilities: [
        equip({ energy: 1, pips: 1, anyPower: 0, domains: ["fury"] }),
      ],
      attachedEventAlias: { hold: "conquer", conquer: "hold" },
    },

    "Spinning Axe": {
      play: [{ op: "attachSource", to: "$_qd" }],
      targets: [
        {
          bind: "_qd",
          spec: { type: "unit", friendly: true },
          prompt: "Attach Spinning Axe to which unit?",
        },
      ],
      abilities: [
        equip({ energy: 0, pips: 0, anyPower: 1, domains: null }),
      ],
    },

    "Relentless Pursuit": {
      targets: [
        { bind: "u", spec: { type: "unit", friendly: true }, prompt: "Move which friendly unit?" },
      ],
      play: [
        { op: "move", to: "$u" },
        {
          op: "may",
          prompt: "Attach an Equipment with the same controller to that unit?",
          then: [
            {
              op: "choose", bind: "g",
              spec: { type: "gear", tag: "Equipment", friendly: true, attached: true },
              prompt: "Attach which Equipment?",
            },
            { op: "attach", to: "$g", host: "$u" },
          ],
        },
        {
          op: "delayed", on: "unitConquer", forEach: "$u", repeat: true,
          label: "{target}: when I conquer, you may move me to my base",
          program: [
            { op: "may", prompt: "Move it to its base?", skip: 1 },
            { op: "move", to: "$ev", dest: "base" },
          ],
        },
      ],
    },

    "Glorious Executioner": {
      triggers: [{
        on: "combatEnd",
        label: "win a combat: draw 1",
        program: [{
          op: "if",
          cond: {
            k: "and",
            conds: [
              { k: "count", spec: { type: "unit", friendly: true, here: true, ignoreUntargetable: true }, n: 1 },
              { k: "count", spec: { type: "unit", enemy: true, here: true, ignoreUntargetable: true }, n: 0, cmp: "exactly" },
            ],
          },
          then: [{ op: "draw", n: 1 }],
        }],
      }],
    },

    "Void Burrower": {
      triggers: [{
        on: "conquer", you: true, optional: true, exhaustSelf: true,
        label: "exhaust me: reveal the top 2 and play one",
        condSpec: { k: "selfReady" },
        program: [
          { op: "exhaust", to: "source" },
          {
            op: "lookTopTake", n: 2, optional: true, public: true,
            prompt: "Play one of the revealed cards (choose none to recycle both)",
          },
        ],
      }],
    },

    "Against the Odds": {
      targets: [{
        bind: "t",
        spec: { type: "unit", friendly: true, atBf: true },
        prompt: "Give which friendly unit at a battlefield +2 Might per enemy unit there?",
      }],
      play: [{
        op: "grant", to: "$t", dur: "turn",
        might: { count: { type: "unit", enemy: true, sameLocAs: "t", ignoreUntargetable: true }, times: 2 },
      }],
    },

    "Blood Rush": {
      targets: [{ bind: "t", spec: { type: "unit" }, prompt: "Give which unit Assault 2?" }],
      play: [{ op: "grant", to: "$t", keyword: "assault", kwValue: 2, dur: "turn" }],
      repeatCosts: [{ cost: { energy: 1, pips: 0, anyPower: 0, domains: null } }],
    },

    Bushwhack: {
      play: [
        { op: "unitsEnterReady" },
        { op: "token", name: "Gold", exhausted: true },
      ],
    },

    Detonate: {
      targets: [{
        bind: "t",
        spec: { type: "gear", attached: true },
        prompt: "Kill which gear?",
      }],
      play: [
        { op: "draw", n: 2, whoOf: "t" },
        { op: "kill", to: "$t" },
      ],
    },

    "Eager Drakehound": { entersReady: true },

    "Void Drone": {
      costMods: [{ fromZone: "notHand", energyLess: 2 }],
    },

    "Angle Shot": {
      play: [
        {
          op: "option", varKey: "side", prompt: "Whose unit and Equipment?",
          options: ["A unit and an Equipment you control", "A unit and an Equipment your opponent controls"],
        },
        {
          op: "if", cond: { k: "varEq", key: "side", value: 0 },
          then: [
            {
              op: "choose", bind: "g",
              spec: { type: "gear", tag: "Equipment", friendly: true, attached: true },
              prompt: "Choose a friendly Equipment",
            },
            {
              op: "choose", bind: "u",
              spec: { type: "unit", friendly: true },
              prompt: "Choose a friendly unit",
            },
          ],
          else: [
            {
              op: "choose", bind: "g",
              spec: { type: "gear", tag: "Equipment", enemy: true, attached: true },
              prompt: "Choose an enemy Equipment",
            },
            {
              op: "choose", bind: "u",
              spec: { type: "unit", enemy: true },
              prompt: "Choose an enemy unit",
            },
          ],
        },
        {
          op: "if",
          cond: {
            k: "count", n: 1,
            spec: { type: "gear", attached: true, isBind: "g", attachedToBind: "u", ignoreUntargetable: true },
          },
          then: [
            {
              op: "option", varKey: "mode", prompt: "Attach or detach?",
              options: ["Attach that Equipment to that unit", "Detach that Equipment from that unit"],
            },
            {
              op: "if", cond: { k: "varEq", key: "mode", value: 0 },
              then: [{ op: "attach", to: "$g", host: "$u" }],
              else: [{ op: "detach", to: "$g" }],
            },
          ],
          else: [{ op: "attach", to: "$g", host: "$u" }],
        },
        { op: "draw", n: 1 },
      ],
    },

    "Battering Ram": {
      costMods: [{ energyLess: { turnFactOf: "played" }, min: 1 }],
    },

    "Blast Corps Cadet": {
      addCosts: [{
        optional: true,
        cond: null,
        label: "Blast Corps Cadet",
        cost: { energy: 1, pips: 1, anyPower: 0, domains: ["fury"] },
        thenTargets: [{
          bind: "t",
          spec: { type: "unit", atBf: true },
          prompt: "Deal 2 to which unit at a battlefield?",
        }],
        then: [{ op: "deal", to: "$t", n: 2 }],
      }],
    },

    "Minotaur Reckoner": {
      restrictMove: [{ who: "all", toBase: true }],
    },

    "Perched Grimwyrm": {
      playOnlyTo: { conqueredThisTurn: true },
    },

    "Sudden Storm": {
      targets: [{
        bind: "t",
        spec: { type: "unit", atBf: true },
        prompt: "Deal damage to which unit at a battlefield?",
      }],
      play: [{
        op: "if", cond: { k: "targetAttacking", bind: "t" },
        then: [{ op: "deal", to: "$t", n: 4 }],
        else: [{ op: "deal", to: "$t", n: 2 }],
      }],
    },

    "Draven, Vanquisher": {
      triggers: [
        {
          on: "combatEnd",
          selfBf: true,
          label: "win a combat: play a Gold token exhausted",
          condSpec: {
            k: "not",
            cond: { k: "count", spec: { type: "unit", enemy: true, here: true, ignoreUntargetable: true } },
          },
          program: [{ op: "token", name: "Gold", exhausted: true }],
        },
        {
          on: "attack",
          self: true,
          label: "attack: pay Fury for +2 Might",
          program: [{
            op: "may", prompt: "Pay 1 Fury to give Draven, Vanquisher +2 Might this turn?",
            then: [
              { op: "payCost", cost: { energy: 0, pips: 1, anyPower: 0, domains: ["fury"] }, varKey: "dravenAtk", skipOnFail: 1 },
              buff("source", 2),
            ],
          }],
        },
        {
          on: "defend",
          self: true,
          label: "defend: pay Fury for +2 Might",
          program: [{
            op: "may", prompt: "Pay 1 Fury to give Draven, Vanquisher +2 Might this turn?",
            then: [
              { op: "payCost", cost: { energy: 0, pips: 1, anyPower: 0, domains: ["fury"] }, varKey: "dravenDef", skipOnFail: 1 },
              buff("source", 2),
            ],
          }],
        },
      ],
    },

    "Piercing Light": {
      targets: [
        { bind: "t1", spec: { type: "unit", atBf: true }, prompt: "Deal 2 to which unit at a battlefield?" },
        {
          bind: "t2", spec: { type: "unit", notBind: "t1" }, min: 0, max: 1,
          prompt: "Deal 2 to up to one other unit",
        },
      ],
      play: [
        { op: "deal", to: "$t1", n: 2 },
        { op: "deal", to: "$t2", n: 2 },
      ],
      repeatCosts: [{ cost: { energy: 2, pips: 1, anyPower: 0, domains: ["fury"] } }],
    },

    "Rell, Magnetic": {
      triggers: [{
        on: "attack",
        self: true,
        label: "play a cheap Equipment attached to me",
        program: [
          {
            op: "choose", bind: "e", min: 0, max: 1,
            spec: { zone: "hand", type: "gear", tag: "Equipment", maxEnergy: 2 },
            prompt: "Play an Equipment costing 2 Energy or less for free, attached to me?",
          },
          {
            op: "if", cond: { k: "targetsChosen", bind: "e" },
            then: [{ op: "playFrom", to: "$e", waive: "all", attachTo: "source" }],
          },
        ],
      }],
    },

    "Rengar, Pouncing": {
      playToAttackedBf: true,
    },

    "Rumble, Hotheaded": {
      auraKwSpecs: [{ name: "assault", value: 1, targetCond: { k: "selfTag", tag: "Mech" } }],
      triggers: [{
        on: "unitConquer",
        self: true,
        label: "conquer: recycle a unit to play a Mech from your trash",
        program: [{
          op: "if", cond: { k: "count", spec: { zone: "trash", type: "unit", tag: "Mech" } },
          then: [{
            op: "may", prompt: "Recycle another friendly unit to play a Mech from your trash for its Might less?",
            then: [
              {
                op: "choose", bind: "r",
                spec: { type: "unit", friendly: true, other: true },
                prompt: "Recycle which other friendly unit?",
              },
              { op: "setVarMight", from: "$r", varKey: "rumbleRecycled" },
              { op: "recycleTargets", to: "$r" },
              {
                op: "choose", bind: "m",
                spec: { zone: "trash", type: "unit", tag: "Mech" },
                prompt: "Play which Mech from your trash?",
              },
              { op: "playFrom", to: "$m", energyLess: { varOf: "rumbleRecycled" } },
            ],
          }],
        }],
      }],
    },

    "Lucian, Gunslinger": {
      triggers: [{
        on: "attack",
        self: true,
        label: "attack: deal my Assault to an enemy unit here",
        targets: [{
          bind: "t",
          spec: { type: "unit", enemy: true, here: true },
          prompt: "Deal damage equal to my Assault to which enemy unit here?",
        }],
        program: [{ op: "deal", to: "$t", n: { kwOf: "source", kw: "assault" } }],
      }],
    },

    "Rek'Sai, Breacher": {
      auraPlayKwSpecs: [{ name: "accelerate", value: null, what: { type: "unit" }, fromZone: "notHand" }],
    },

    Dunebreaker: {
      entersReadyCond: { k: "handMax", n: 2 },
      triggers: [{
        on: "unitHold",
        self: true,
        label: "hold: draw 2",
        program: [{ op: "draw", n: 2 }],
      }],
    },

    "Void Hatchling": {
      deckRevealPeek: true,
    },

    "Mechanized Menace": {
      auraKwSpecs: [{ name: "shield", value: null, targetCond: { k: "selfTag", tag: "Mech" } }],
    },

    "Purifier": {
      auraKw(state, src, iid) {
        const o = state.objs[iid];
        const so = state.objs[src];
        if (!o || o.zone !== "board" || !so || so.controller !== o.controller) return [];
        const out = [];
        for (const aIid of o.attachments || []) {
          const asc = window.RB.Scripts.forCard(state, aIid);
          if (asc && (asc.abilities || []).some(function (ab) { return ab.label === "Equip"; })) {
            out.push(["assault", 1]);
          }
        }
        return out;
      },
    },

    "Void Rush": {
      play: [{
        op: "lookTopTake", n: 2, optional: true, public: true,
        energyLess: 2, restTo: "hand",
        prompt: "Play one of them for 2 less (choose none to draw both)",
      }],
    },
  });
})();
